<template>
    <csp-form-select-searchable
        label="Benutzerwechsel"
        :options-loader="loadUserOptions"
        style="min-width: 500px;"
        :value="user"
        @change="selectUser"/>
</template>

<script>
    import Container from '@services/Container';
    import SelectSearchable from '@components/form/SelectSearchable.vue';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();
    const ajaxService = container.getAjaxService();

    export default {
        components: {
            'csp-form-select-searchable': SelectSearchable,
        },
        props: {
            module: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                user: null,
            }
        },
        methods: {
            loadUserOptions() {
                return recordRepository.loadLegacySelectOptions('adminUserSelect', {'moduleName' : this.module});
            },
            selectUser(user) {
                if (!user) {
                    return;
                }
                const userId = user.value;
                // Path must be exaclty this, see \Csp_Session_SaveHandler_DbTable::$_writeEnabledAjaxRequests
                const url = '/de/Portal/Admin/userselect/format/json/userId/' + userId;
                ajaxService.postJson(url, {})
                    .then(() => {
                        window.location.reload();
                    })
            },
        },
    }
</script>
